import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { object } from "yup";

import { ProofOfAddressInputField } from "./ProofOfAddressInputField";
import { ProofOfAddressSummaryField } from "./ProofOfAddressSummaryField";
import { FieldType } from "../types";

export function ProofOfAddressField(
  field: components["schemas"]["ProofOfAddressCheckField"]
): FieldType<components["schemas"]["ProofOfAddressCheckField"]> {
  return {
    field,
    inputElement: <ProofOfAddressInputField key={field.name} field={field} />,
    summaryElement: () => (
      <ProofOfAddressSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value,
    schema: object().required(t("This field is required")),
  };
}
